import { IDeleteItemProcessoRiscosUseCase } from "../../../presentation/useCases/delete/delete_item_processos_riscos_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteItemProcessoRiscosUseCase

export class DeleteItemProcessoRiscosUseCase implements IDeleteItemProcessoRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteItemProcessoRiscos( IdItemProcesso: number,IdProcesso: number): Promise<void> {
    
    await this.repository.deleteItemProcessoRiscos(IdItemProcesso, IdProcesso );
  }
}
